import React from 'react'
// import { useTreeItem } from '@mui/lab/TreeItem';
import { useTreeItem } from '@mui/x-tree-view/TreeItem';

import clsx from "clsx";
import Typography from "@mui/material/Typography";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as Delete } from "../../../../../../assets/img/svg/CloseIcon.svg";

const CustomTreeItemAdded = React.forwardRef(function CustomContent(props, ref) {
    const {
      classes,
      className,
      label,
      nodeId,
      icon: iconProp,
      expansionIcon,
      displayIcon,
      onClick:onClickData
    } = props;
  
    const {
      disabled,
      expanded,
      selected,
      focused,
      handleExpansion,
      handleSelection,
      preventSelection,
    } = useTreeItem(nodeId);
    const {data, mutator}  = onClickData
  
    const icon = iconProp || expansionIcon || displayIcon;
  
    const handleMouseDown = (event) => {
      preventSelection(event);
    };
  
    const handleExpansionClick = (event) => {
      handleExpansion(event);
    };
  
    const handleSelectionClick = (event) => {
      handleSelection(event);
    };
    
    const addHandler = (event,data) =>{
       if(!expanded && data?.nodeType === 'Chapter'){
           handleExpansion(event) ;
           mutator(data)
       }
    }
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div
        className={clsx(className, classes.root, {
          [classes.expanded]: expanded,
          [classes.selected]: selected,
          [classes.focused]: focused,
          [classes.disabled]: disabled,
        })}
        onMouseDown={handleMouseDown}
        ref={ref}
      >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div onClick={handleExpansionClick} className={classes.iconContainer}>
          {icon}
        </div>
        <Typography
          onClick={handleSelectionClick}
          component="div"
          className={classes.label}
        >
          {label}
        </Typography>
        <Delete onClick ={()=>mutator(data)}/>
      </div>
    );
  });

export default CustomTreeItemAdded